module.exports = __webpack_public_path__ + "static/media/favicon-dark-mode.14b44830.ico";